import { requestKarangoApi } from "../../core/api/karangoTransport";

const DEFAULT_CONNECTION_CATEGORY = "ACQUAINTANCE";

function encodeId(value) {
  return encodeURIComponent(String(value));
}

export async function getRemoteConnectionStatus(userId, { signal } = {}) {
  if (!userId) return { status: "none" };
  const payload = await requestKarangoApi(
    `/v1/connections/status/${encodeId(userId)}`,
    { requiresAuth: true, signal }
  );
  return payload ?? { status: "none" };
}

export async function sendRemoteConnectionRequest(targetId) {
  if (!targetId) throw new Error("targetId requis.");
  return requestKarangoApi("/v1/connections/requests", {
    method: "POST",
    requiresAuth: true,
    body: { targetId },
  });
}

export async function acceptRemoteConnectionRequest(
  connectionId,
  { category = DEFAULT_CONNECTION_CATEGORY } = {}
) {
  if (!connectionId) throw new Error("connectionId requis.");
  return requestKarangoApi(`/v1/connections/${encodeId(connectionId)}/accept`, {
    method: "POST",
    requiresAuth: true,
    body: { category },
  });
}

export async function refuseRemoteConnectionRequest(connectionId) {
  if (!connectionId) throw new Error("connectionId requis.");
  return requestKarangoApi(`/v1/connections/${encodeId(connectionId)}/refuse`, {
    method: "POST",
    requiresAuth: true,
  });
}

export async function cancelRemoteConnectionRequest(connectionId) {
  if (!connectionId) throw new Error("connectionId requis.");
  return requestKarangoApi(`/v1/connections/${encodeId(connectionId)}/cancel`, {
    method: "POST",
    requiresAuth: true,
  });
}

export async function deleteRemoteConnection(connectionId) {
  if (!connectionId) throw new Error("connectionId requis.");
  return requestKarangoApi(`/v1/connections/${encodeId(connectionId)}`, {
    method: "DELETE",
    requiresAuth: true,
  });
}

export async function updateRemoteConnectionCategory(connectionId, category) {
  if (!connectionId) throw new Error("connectionId requis.");
  if (!category) throw new Error("category requis.");
  return requestKarangoApi(`/v1/connections/${encodeId(connectionId)}/category`, {
    method: "PATCH",
    requiresAuth: true,
    body: { category },
  });
}

export async function listRemoteConnections({ signal } = {}) {
  const payload = await requestKarangoApi("/v1/connections", {
    requiresAuth: true,
    signal,
  });
  return { connections: Array.isArray(payload?.connections) ? payload.connections : [] };
}

export async function listRemoteIncomingConnectionRequests({ signal } = {}) {
  const payload = await requestKarangoApi("/v1/connections/requests/incoming", {
    requiresAuth: true,
    signal,
  });
  return { requests: Array.isArray(payload?.requests) ? payload.requests : [] };
}

export async function listRemoteOutgoingConnectionRequests({ signal } = {}) {
  const payload = await requestKarangoApi("/v1/connections/requests/outgoing", {
    requiresAuth: true,
    signal,
  });
  return { requests: Array.isArray(payload?.requests) ? payload.requests : [] };
}
